import { useMemo } from 'react';

import type { SvpAsset } from '@vgtv/api-client/lib/svp_asset';
import { ComponentType } from '@vgtv/api-client/lib/component';

import { useAppSelector } from '../../modules/hooks';
import { selectWatchtimeHistoryMappedByAssetId } from '../../modules/watchtime';

const useSortAssets = <T extends SvpAsset>(
  assets: T[],
  componentType: ComponentType
): T[] => {
  const watchtimeHistoryMappedByAssetId = useAppSelector(
    selectWatchtimeHistoryMappedByAssetId
  );

  return useMemo(() => {
    if (componentType === ComponentType.CONTINUE_WATCHING) {
      return [...assets].sort((a, b) => {
        return (
          watchtimeHistoryMappedByAssetId[b.id] -
          watchtimeHistoryMappedByAssetId[a.id]
        );
      });
    }

    return assets;
  }, [assets, componentType, watchtimeHistoryMappedByAssetId]);
};

export { useSortAssets };
